import React from 'react'
import styles from './Style.module.css'
import IconMale from '../../../Assets/Images/boy.png'
import IconFemale from '../../../Assets/Images/girl.png'
import TherapistIcon from '../../../Assets/Images/no-preference.png'

const TherapistCard = ({ therapist, isBusy, selectTherapist, isSelected }) => {
  return (
    <div 
    key={therapist?.id} 
    className={`
    ${styles.therapistCard} 
    ${isBusy ? styles.busy : ""}
    ${isSelected ? styles.selected : ""}
    space-x
    `} 
    onClick={() => selectTherapist(therapist)}
    title={isBusy ? `${therapist?.alias} (busy)` : therapist?.alias}
    aria-disabled={isBusy}
    >
        <img src={therapist?.gender === 'male' ? IconMale : therapist?.gender === 'female' ? IconFemale : TherapistIcon} alt='' className={styles.icon}/>
        <div className={styles.text}>
            <div>{therapist?.alias}</div>
            {isBusy && <div className={styles.badgeBusy}>Busy</div>}
        </div>
    </div>
  )
}

export default TherapistCard